import types from 'frontend/state/actionTypes';

const INITIAL_SELECTED_SAVED_GEARSET = 'empty';

const selectedSavedGearset = (state = INITIAL_SELECTED_SAVED_GEARSET, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.CHOOSE_SAVED_GEARSET:
      return payload.savedGearsetId || INITIAL_SELECTED_SAVED_GEARSET;
    case types.ADD_GEARSET: // reset after adding
    case types.DELETE_SAVED_GEARSET: // reset after deleting
      return INITIAL_SELECTED_SAVED_GEARSET;
    default:
      return state;
  }
};

export default selectedSavedGearset;

export const selectors = {
  selectedSavedGearset: state => state.simbot.selectedSavedGearset,
};
